import {
  FaFacebookSquare,
  FaLinkedin,
  FaTwitterSquare,
  FaInstagram,
  FaYoutube
} from 'react-icons/fa'
import s from './SocialMedia.scss'

const SocialMedia = ({ facebook, twitter, linkedin, instagram, youtube }) => (
  <div className={s.socialMedia}>
    {facebook && (
      <p>
        <a href={facebook} target="_blank" rel="noopener noreferrer">
          <FaFacebookSquare />
        </a>
      </p>
    )}
    {linkedin && (
      <p>
        <a href={linkedin} target="_blank" rel="noopener noreferrer">
          <FaLinkedin />
        </a>
      </p>
    )}
    {twitter && (
      <p>
        <a href={twitter} target="_blank" rel="noopener noreferrer">
          <FaTwitterSquare />
        </a>
      </p>
    )}
    {instagram && (
      <p>
        <a href={instagram} target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
      </p>
    )}
    {youtube && (
      <p>
        <a href={youtube} target="_blank" rel="noopener noreferrer">
          <FaYoutube />
        </a>
      </p>
    )}
  </div>
)

export default SocialMedia
